<template>
  <v-layout style="padding:20px;">
    <v-flex xs12>
      <v-card dense class="pa-0 ma-0">
        <v-card-title flat dense color="white" class="pa-0 pl-3 pr-3 subheading">
          <strong>Data Sets</strong>
          <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            outline
            append-icon="search"
            placeholder="Search"
            class="black--text"
            color="black"
             single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>

          <v-icon title="Add" small flat class="black--text" @click="DatasetAdd()">fa fa-plus</v-icon>
          <!-- <FilterDrawer filterKey="dataSet" v-on:applyFilter="applyFilter" /> -->
                <!-- <v-icon title="Print" small flat class="black--text">fa fa-print</v-icon>
                <v-icon title="Download" small flat class="black--text">fa fa-download</v-icon>
                <v-icon title="Save" small flat class="black--text">fa fa-saveas</v-icon>-->
          <!-- <Help kbCategoryCode="DS" /> -->
         <!-- <PrintDocument class="prt" :headers="headers" :printData="dataset" /> -->
          <!-- <DataUpload modelName="DataSet" /> -->
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="dataset"
            :search="search"
            select-all
            :pagination.sync="pagination"
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
              </td>
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.data_source }}</td>
              <td class="text-xs-left">{{type(props.item.type)}}</td>
              <td class="text-xs-left indigo--text font-weight-bold">
                {{ props.item.created ? moment(props.item.created.slice(0,19).replace('T',' ')).format('MMM DD,YYYY') : ''}}
                <br />
                <span class="grey--text">
                  <small>{{ props.item.created ? moment(props.item.created.slice(0,19).replace('T',' ')).fromNow() : ''}}</small>
                </span>
              </td>
              <td class="text-xs-left indigo--text font-weight-bold">
                {{ props.item.modified ? moment(props.item.modified.slice(0,19).replace('T',' ')).format('MMM DD,YYYY') : ''}}
                <br />
                <span class="grey--text">
                  <small>{{ props.item.modified ? moment(props.item.modified.slice(0,19).replace('T',' ')).fromNow() : ''}}</small>
                </span>
              </td>
              <td class="text-xs-left">
                <v-chip
                  small
                  color="primary"
                  text-color="white"
                >{{ props.item.active==1? 'Active':'Inactive'}}</v-chip>
              </td>
              <td>
                <v-icon title="Edit" small @click="editItem(props.item)">fas fa-edit</v-icon>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert>
          </v-data-table>
        </v-card-text>
        <v-dialog
          v-model="entryModal"
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
          max-width="600px"
        >
          <DataSetEdit v-if="editFlag" :parameters="editData" v-on:closeDialog="closeDialog1" />
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import DataSetModel from "@/api/service/DataSetService";
import moment from "moment";
import DataSetEdit from "./edit.vue";
//import PrintDocument from "@/components/PrintComponent.vue";
//import FilterDrawer from "@/components/FilterDrawer.vue";
//import Help from "@/components/HelpComponent.vue";
//import DataUpload from '@/components/DataUpload.vue'
export default {
  components: {
    DataSetEdit,
   // FilterDrawer,
   // PrintDocument,
    //DataUpload,
   // Help
  },
  data() {
    return {
      search: "",
      editFlag: false,
      editData: {},
      rowsPerPageItems: ["50", "100", "200", "400", "All"],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: "id",
        totalItems: 0,
        rowsPerPageItems: [1, 2, 4, 8, 16]
      },
      entryModal: false,
      selected: [],
      headers: [
        { text: "Id", value: "id", pwidth: 30 },
        { text: "Name", value: "name", pwidth: 30 },
        { text: "Source", value: "source", pwidth: 30 },
        { text: "Type", value: "type", pwidth: 30 },
        { text: "Created", value: "created", pwidth: 30 },
        { text: "Modified", value: "modified", pwidth: 30 },
        { text: "Status", value: "active", pwidth: 30 },
        {}
      ],
      dataset: []
    };
  },
  created: function() {
    DataSetModel.findAll({})
      .then(response => {
        this.setDataset(response);
      })
      .catch(error => {
        console.log(error);
      });
  },
  mounted: function() {},
  methods: {
    moment,
    setDataset($dataset) {
      this.dataset = $dataset;
    },
    closeDialog1() {
      DataSetModel.findAll({})
        .then(response => {
          this.setDataset(response);
        })
        .catch(error => {
          console.log(error);
        });
      this.entryModal = false;
      this.editFlag = false;
    },
    editItem($item) {
      this.editData = Object.assign($item);
      this.entryModal = true;
      this.editFlag = true;
    },
    DatasetAdd() {
      this.entryModal = true;
      this.editFlag = true;
      this.editData = {};
    },
    type($dataset) {
      if ($dataset == "D") {
        return "DropDown";
      } else {
        return "Report";
      }
    },
    applyFilter($filter) {
      DataSetModel.findAll($filter)
        .then(response => {
          this.setDataset(response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
</style>